import { useState, useEffect } from 'react';

export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= breakpoint);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}

export function getInitialIndexSlide(cardsLength) {
  return Math.round(cardsLength / 2) - 1;
}

export function getResponsiveImageUrl(imageUrl, mobileImageUrl, isMobile) {
  return isMobile ? (mobileImageUrl || imageUrl) : (imageUrl || mobileImageUrl);
}

// Keeps the slide of a keyboard-focused element fully in view instead of
// relying on the browser's native scrollIntoView, which cuts slides off
// mid-way when they sit outside the swiper's visible/transformed area.
export function focusSlideIntoView(swiper, focusTarget) {
  if (!swiper || !focusTarget || swiper.destroyed) return;

  const slideEl = focusTarget.closest('.swiper-slide');
  if (!slideEl) return;

  const index = Array.from(swiper.slides || []).indexOf(slideEl);
  if (index === -1 || index === swiper.activeIndex) return;

  swiper.slideTo(index);
}

// Autoplay auto-advances while a keyboard user is still reading/interacting
// with a slide, which fails WCAG 2.2.2 and makes navigation feel erratic.
// Pause it while focus is inside the carousel, resume once focus leaves.
export function pauseAutoplayOnFocus(swiper) {
  swiper?.autoplay?.stop();
}

export function resumeAutoplayOnBlur(swiper, container, relatedTarget) {
  if (relatedTarget && container?.contains(relatedTarget)) return;
  swiper?.autoplay?.start();
}
